module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [_c('comp-menu'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('comp-toaster'), _vm._v(" "), _c('div', {
    staticClass: "clickable-layer-to-close-menu",
    on: {
      "click": function($event) {
        _vm.closeMenu()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(!_vm.isOnline) ? _c('div', {
    staticClass: "unclickable-layer-to-close-menu"
  }, [_vm._v("\n    Check network connection\n  ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10b6a574","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site.vue
// module id = 271
// module chunks = 1